import { createContext } from "react";

const JurisdictionContext = createContext();

export default JurisdictionContext;
